import { hasCookie, setCookie } from 'cookies-next';
import { useEffect, useState } from 'react';
import { Button, ButtonVariant } from './button';

export function TrackingConsent({
  info,
  acceptAllLabel,
  declineAllLabel,
}: {
  info: string;
  acceptAllLabel: string;
  declineAllLabel: string;
}) {
  const [decided, setDecided] = useState(true);
  const maxAge = 60 * 60 * 24 * 365;

  useEffect(() => {
    setDecided(hasCookie('localConsent'));
  }, []);

  const acceptCookie = () => {
    setDecided(true);
    setCookie('localConsent', 'true', { maxAge });
    gtag('consent', 'update', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted',
    });
  };

  const denyCookie = () => {
    setDecided(true);
    setCookie('localConsent', 'false', { maxAge });
    gtag('consent', 'update', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
    });
  };

  if (decided) {
    return null;
  }

  return (
    <div className="flex w-full items-center border-b-[1px] border-blue-200">
      <div className="flex w-full max-w-screen-4xl mx-auto flex-col md:flex-row md:items-center py-3 px-6 md:px-12 gap-3">
        <div
          className="flex-1 prose tracking-consent"
          dangerouslySetInnerHTML={{ __html: info }}
        />
        <div className="flex-0 hidden md:flex gap-3">
          <Button
            onClick={denyCookie}
            label={declineAllLabel}
            variant={ButtonVariant.Primary}
          />
          <Button
            onClick={acceptCookie}
            label={acceptAllLabel}
            variant={ButtonVariant.Primary}
          />
        </div>
        <div className="flex-0 flex md:hidden gap-3 w-full justify-between">
          <Button
            className="px-0"
            onClick={denyCookie}
            label={declineAllLabel}
            variant={ButtonVariant.PrimaryNegative}
          />
          <Button
            className="px-0"
            onClick={acceptCookie}
            label={acceptAllLabel}
            variant={ButtonVariant.PrimaryNegative}
          />
        </div>
      </div>
    </div>
  );
}
